exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".group[data-v-e1c93114]{margin-top:15px;margin-left:30px}.group-button[data-v-e1c93114]{float:right;margin-right:35px}.red-text[data-v-e1c93114]{color:red}", "", {"version":3,"sources":["/workspace/src/views/order-review/components/RecommendOrder.vue"],"names":[],"mappings":"AACA,wBACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,+BACE,YAAa,AACb,iBAAmB,CACpB,AACD,2BACE,SAAW,CACZ","file":"RecommendOrder.vue","sourcesContent":["\n.group[data-v-e1c93114] {\n  margin-top: 15px;\n  margin-left: 30px;\n}\n.group-button[data-v-e1c93114] {\n  float: right;\n  margin-right: 35px;\n}\n.red-text[data-v-e1c93114] {\n  color: red;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e1c93114","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order-review/components/RecommendOrder.vue
// module id = 4755
// module chunks = 5